import React from 'react';

const TermsAndConditionsPage = () => {
  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold text-center mb-6">Terms & Conditions</h1>
      
      <div className="mt-4">
        <p className="mb-4">
          Welcome to Dash Dynamics. This website is owned and operated by Dash Dynamics. Visitors to this website are bound by the following terms and conditions. For the purposes of these terms and conditions, "this website" refers to Dash Dynamics' official website, which may link to other affiliated websites.
        </p>
        <p className="mb-4">
          Other affiliated websites may contain terms and conditions different from those stated here. When navigating through Dash Dynamics' websites, please check the terms and conditions of each website and do not assume that these terms apply universally.
        </p>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Terms & Conditions</h2>
        <p className="mb-4">
          This website contains material including text, photographs, images, and other media, which are protected by copyright and/or other intellectual property rights. All copyright and intellectual property rights in this material are owned by Dash Dynamics or have been licensed for use on this website.
        </p>
        <p className="mb-4">
          This website also contains trademarks, including the mark "Dash Dynamics" and its emblem. All trademarks included on this website belong to Dash Dynamics or have been licensed for use on this website.
        </p>
        
        <h3 className="text-lg font-bold mt-6 mb-2">You may:</h3>
        <p className="mb-1">a) Access any part of the website.</p>
        <p className="mb-4">b) Print a single copy of any or all pages for personal reference.</p>
        
        <h3 className="text-lg font-bold mt-6 mb-2">You may not:</h3>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">Copy (whether by printing, storing, downloading, or by any other means), distribute, broadcast, alter, or tamper with any material on the website, except as permitted under "You may."</li>
          <li className="mb-2">Remove any copyright, trademark, or other intellectual property notices from any material copied or printed from the website.</li>
          <li className="mb-2">Link to this website without express written consent.</li>
        </ul>
        
        <p className="mb-4">
          If you wish to provide a hypertext or other link to this website, please contact the website administrator with details of:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">The URL(s) of the web page(s) from which you propose to link to this website.</li>
          <li className="mb-2">The URL(s) of the web page(s) on this website to which you propose to link.</li>
        </ul>
        <p className="mb-4">
          We have the sole discretion to accept or reject such requests.
        </p>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Changes in Terms & Conditions</h2>
        <p className="mb-4">
          Dash Dynamics reserves the right to change the terms and conditions and disclaimers at any time. By browsing this website, you agree to be bound by the latest version of these terms and conditions, and it is your responsibility to check for updates.
        </p>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Changes in Website Operations</h2>
        <p className="mb-4">
          Dash Dynamics may:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">Modify the format and content of this website at any time.</li>
          <li className="mb-2">Suspend website operation for maintenance, updates, or other reasons.</li>
          <li className="mb-2">Terminate website access at any time without prior notice.</li>
        </ul>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Data Protection</h2>
        <p className="mb-4">
          Personal details provided to Dash Dynamics through this website will only be used in accordance with our Privacy Policy. By submitting your personal details, you consent to their use as outlined in our Privacy Policy.
        </p>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Complaints</h2>
        <p className="mb-4">
          If you have a question or complaint regarding this website, please contact the Dash Dynamics Administrator.
        </p>
        
        <h2 className="text-xl font-bold mt-6 mb-2">Jurisdiction</h2>
        <p className="mb-4">
          These terms and conditions are governed by and shall be interpreted in accordance with the relevant laws. Any disputes arising from these terms or the website's use shall be subject to the exclusive jurisdiction of the courts in the applicable location.
        </p>
      </div>
    </div>
  );
};


export default TermsAndConditionsPage;
